/* istanbul ignore file */

export const RELATED_CATEGORIES_TITLE = 'You might also like';

// Placeholder copy, pending Design (DISC-4626).
export const NO_MATCHING_PRODUCTS_HEADING = 'No products match these filters';
export const NO_MATCHING_PRODUCTS_HINT = 'Remove a filter to see more.';
